/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var IconVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IconVisualModelExport, _super);
    function IconVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.c = null;
        _this.b = null;
        _this.d = 0;
        _this._svgPath = null;
        _this.j = null;
        _this.k = null;
        _this.l = null;
        _this.e = 0;
        _this.h = null;
        _this.i = null;
        return _this;
    }
    Object.defineProperty(IconVisualModelExport.prototype, "svgPath", {
        get: function () {
            return this._svgPath;
        },
        set: function (a) {
            this._svgPath = a;
        },
        enumerable: true,
        configurable: true
    });
    IconVisualModelExport.prototype.f = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("actualFill : " + this.a.serialize() + ", ");
        a.l("actualTextColor : " + this.c.serialize() + ", ");
        a.l("actualStroke : " + this.b.serialize() + ", ");
        a.l("actualStrokeThickness : " + this.d + ", ");
        if (!stringIsNullOrEmpty(this.j)) {
            a.l("textStyleFontStyle : \"" + this.j + "\", ");
        }
        if (!stringIsNullOrEmpty(this.k)) {
            a.l("textStyleFontVariant : \"" + this.k + "\", ");
        }
        if (!stringIsNullOrEmpty(this.l)) {
            a.l("textStyleFontWeight : \"" + this.l + "\", ");
        }
        if (!stringIsNullOrEmpty(this.h)) {
            a.l("textStyleFontFamily : \"" + this.h + "\", ");
        }
        if (!stringIsNullOrEmpty(this.i)) {
            a.l("textStyleFontStretch : \"" + this.i + "\", ");
        }
        if (!isNaN_(this.e)) {
            a.l("textStyleFontSize : " + this.e + ", ");
        }
        a.l("}");
        return a.toString();
    };
    IconVisualModelExport.$t = markType(IconVisualModelExport, 'IconVisualModelExport');
    return IconVisualModelExport;
}(Base));
export { IconVisualModelExport };
//# sourceMappingURL=IconVisualModelExport.js.map
